import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {
    Component, 
    ElementRef, 
    Input, 
    Output, 
    OnChanges, 
    OnDestroy, 
    SimpleChanges
} from '@angular/core';


@Component({
    selector: 'al-react-wrapper',
    template: `<div>
                <ng-content>
                </ng-content>
               </div>`
})
export class AlReactWrapperComponent<PropertiesType = any>
                implements OnChanges, OnDestroy 
{

    @Input() props?:PropertiesType;
    @Input() component?:any;

    protected reactComponent?:any;
    protected reactComponentInstance?:any;

    constructor( public element:ElementRef ) {
    }

    ngOnChanges( changes:SimpleChanges ) {
        if ( this.props && this.component && ! this.reactComponentInstance ) {
            console.log("Creating instance!" );
            let root = ReactDOM.createRoot( this.element.nativeElement );
            this.reactComponent = React.createElement( this.component, this.props );
            const callback = () => {
                console.log("In callback!" );
            };
            this.reactComponentInstance = root.render( this.reactComponent );

        } else if ( this.reactComponentInstance && 'props' in changes ) {
            console.log("Updating instance!" );
            this.reactComponentInstance.setState( this.props );
        }
    }

    ngOnDestroy() {
    }
}
